import React from "react";
import { ChevronDown } from "lucide-react";

const dropdownContainerClasses = "absolute left-0 pt-1 bg-transparent z-50";
const dropdownInnerClasses = "py-2 bg-gray-900/95 backdrop-blur-xl border border-gray-700 rounded-xl shadow-2xl transition-all duration-200 origin-top";

const NavDropdown = ({ name, label, labelClassName, width, openDropdown, setOpenDropdown, toggleDropdown, children }) => (
  <div
    className="relative dropdown-container"
    onMouseEnter={() => setOpenDropdown(name)}
    onMouseLeave={() => setOpenDropdown(null)}
  >
    <button
      onClick={() => toggleDropdown(name)}
      className={labelClassName}
    >
      {label}
      <ChevronDown className={`w-3 h-3 transition-transform duration-200 ${openDropdown === name ? 'rotate-180' : ''}`} />
    </button>
    <div className={`${dropdownContainerClasses} ${width} ${openDropdown === name ? '' : 'pointer-events-none'}`}>
      <div className={`${dropdownInnerClasses} ${openDropdown === name ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
        {children}
      </div>
    </div>
  </div>
);

const ddItemClass = (extra = "text-gray-300 hover:text-white hover:bg-white/10") =>
  `w-full px-4 py-2.5 text-sm text-left transition-colors ${extra}`;

export const ContenidoDropdown = ({ openDropdown, setOpenDropdown, toggleDropdown, handleNavigate }) => (
  <NavDropdown
    name="contenido"
    label="Contenido"
    labelClassName="px-3 py-2 text-sm text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-all duration-200 flex items-center gap-1"
    width="w-48"
    openDropdown={openDropdown}
    setOpenDropdown={setOpenDropdown}
    toggleDropdown={toggleDropdown}
  >
    <button onClick={() => handleNavigate("/documents")} className={ddItemClass()}>Documentos</button>
    <button onClick={() => handleNavigate("/templates")} className={ddItemClass()}>Plantillas</button>
    <button onClick={() => handleNavigate("/social-studio")} className={ddItemClass("text-pink-400 hover:text-pink-300 hover:bg-pink-500/10")} data-testid="nav-social-studio-link">Social Studio</button>
    <button onClick={() => handleNavigate("/smm")} className={ddItemClass("text-fuchsia-400 hover:text-fuchsia-300 hover:bg-fuchsia-500/10")} data-testid="nav-smm-link">SMM Officer</button>
    <button onClick={() => handleNavigate("/brand-setup")} className={ddItemClass("text-purple-400 hover:text-purple-300 hover:bg-purple-500/10")}>Personalizar Marca</button>
  </NavDropdown>
);

export const HerramientasDropdown = ({ openDropdown, setOpenDropdown, toggleDropdown, handleNavigate }) => (
  <NavDropdown
    name="herramientas"
    label="Herramientas"
    labelClassName="px-3 py-2 text-sm text-purple-400 hover:text-purple-300 hover:bg-purple-500/10 rounded-lg transition-all duration-200 flex items-center gap-1 font-medium"
    width="w-56"
    openDropdown={openDropdown}
    setOpenDropdown={setOpenDropdown}
    toggleDropdown={toggleDropdown}
  >
    <button onClick={() => handleNavigate("/startup-hub")} className={ddItemClass("text-purple-400 hover:text-purple-300 hover:bg-purple-500/10")}>Startup Hub</button>
    <button onClick={() => handleNavigate("/pr-toolkit")} className={ddItemClass("text-cyan-400 hover:text-cyan-300 hover:bg-cyan-500/10")} data-testid="nav-pr-toolkit-link">PR Toolkit</button>
    <button onClick={() => handleNavigate("/sentiment")} className={ddItemClass("text-emerald-400 hover:text-emerald-300 hover:bg-emerald-500/10")} data-testid="nav-sentiment-link">Sentiment Engine</button>
    <button onClick={() => handleNavigate("/intelligence")} className={ddItemClass("text-rose-400 hover:text-rose-300 hover:bg-rose-500/10")} data-testid="nav-intelligence-link">Intelligence Radar</button>
    <button onClick={() => handleNavigate("/risk")} className={ddItemClass("text-amber-400 hover:text-amber-300 hover:bg-amber-500/10")} data-testid="nav-risk-engine-link">Risk Engine</button>
    <button onClick={() => handleNavigate("/briefs")} className={ddItemClass("text-cyan-400 hover:text-cyan-300 hover:bg-cyan-500/10")} data-testid="nav-briefs-link">Brief Generator</button>
    <button onClick={() => handleNavigate("/stakeholder-map")} className={ddItemClass("text-pink-400 hover:text-pink-300 hover:bg-pink-500/10")} data-testid="nav-stakeholder-map-link">Stakeholder Map</button>
    <button onClick={() => handleNavigate("/forecast")} className={ddItemClass("text-emerald-400 hover:text-emerald-300 hover:bg-emerald-500/10")} data-testid="nav-forecast-link">Reputation Forecast</button>
    <button onClick={() => handleNavigate("/crisis-simulator")} className={ddItemClass()}>Simulador de Crisis</button>
    <button onClick={() => handleNavigate("/ai-tools")} className={ddItemClass()}>IA Tools</button>
    <div className="mx-3 my-1 h-px bg-white/[0.06]" />
    <p className="px-4 py-1 text-[10px] uppercase text-gray-600 tracking-wider">Análisis Estratégico</p>
    <button onClick={() => handleNavigate("/ai-tools?tab=diagnostico")} className={ddItemClass()}>Diagnóstico PR</button>
    <button onClick={() => handleNavigate("/ai-tools?tab=foda")} className={ddItemClass()}>Análisis FODA</button>
    <button onClick={() => handleNavigate("/ai-tools?tab=estrategia")} className={ddItemClass()}>Estrategia PR</button>
    <button onClick={() => handleNavigate("/advanced")} className={ddItemClass()}>Avanzado</button>
  </NavDropdown>
);

export const MonitoreoDropdown = ({ openDropdown, setOpenDropdown, toggleDropdown, handleNavigate }) => (
  <NavDropdown
    name="monitoreo"
    label="Monitoreo"
    labelClassName="px-3 py-2 text-sm text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-all duration-200 flex items-center gap-1"
    width="w-48"
    openDropdown={openDropdown}
    setOpenDropdown={setOpenDropdown}
    toggleDropdown={toggleDropdown}
  >
    <button onClick={() => handleNavigate("/api-integrations")} className={ddItemClass("text-emerald-400 hover:text-emerald-300 hover:bg-emerald-500/10")}>Configurar APIs</button>
    <button onClick={() => handleNavigate("/social-connections")} className={ddItemClass("text-cyan-400 hover:text-cyan-300 hover:bg-cyan-500/10")}>Conexiones</button>
    <button onClick={() => handleNavigate("/social-connect")} className={ddItemClass("text-violet-400 hover:text-violet-300 hover:bg-violet-500/10")} data-testid="nav-social-connect-link">Social Connect</button>
    <button onClick={() => handleNavigate("/media-directory")} className={ddItemClass("text-amber-400 hover:text-amber-300 hover:bg-amber-500/10")} data-testid="nav-media-directory-link">Media Directory</button>
    <button onClick={() => handleNavigate("/social")} className={ddItemClass()}>Escucha Social</button>
    <button onClick={() => handleNavigate("/alerts")} className={ddItemClass()}>Alertas</button>
    <button onClick={() => handleNavigate("/media-impact")} className={ddItemClass()}>Media Impact</button>
    <button onClick={() => handleNavigate("/stakeholders")} className={ddItemClass()}>Stakeholders</button>
    <div className="my-1 border-t border-white/[0.05]"></div>
    <button onClick={() => handleNavigate("/political-intel")} className={ddItemClass("text-pink-400 hover:text-pink-300 hover:bg-pink-500/10 font-medium")} data-testid="nav-political-intel">Political Intel · DEMO</button>
  </NavDropdown>
);
